import React from 'react';
import { Stack, Select, MenuItem, SelectChangeEvent, FormControl } from '@mui/material';
import { useRiskPoolOrgContext } from '../RiskPoolOrgContext';

interface FiltersProps {
  allOrganizations?: Array<{ id: string; name: string }>;
  onOrgChange: (event: SelectChangeEvent<string>) => void;
}

export default function Filters({ allOrganizations, onOrgChange }: FiltersProps) {
  const { orgId } = useRiskPoolOrgContext();

  if (!allOrganizations || allOrganizations.length === 0) {
    return null;
  }

  return (
    <Stack direction='row' spacing={2} alignItems='center'>
      <FormControl size='small' sx={{ p: 0 }}>
        <Select
          value={orgId}
          onChange={onOrgChange}
          displayEmpty
          sx={{
            minWidth: 200,
            backgroundColor: 'white',
            '& .MuiSelect-select': { py: 1 },
          }}
        >
          {allOrganizations.map((org) => (
            <MenuItem key={org.id} value={org.id}>
              {org.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
}
